import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";
import { withTranslation } from "react-i18next";
import type { WithTranslation } from "react-i18next";

interface Props extends WithTranslation {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Последний рубеж: если экран упал на рендере, пользователь должен увидеть
 * текст, а не белую страницу. Критерий закрытия фазы сформулирован дословно
 * так — «ни один экран не показывает пустоту вместо загрузки или ошибки».
 */
class ErrorBoundaryBase extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[app] экран упал", error, info.componentStack);
  }

  override render(): ReactNode {
    const { t, children } = this.props;
    if (!this.state.hasError) return children;

    return (
      <section className="flex min-h-dvh flex-col items-center justify-center gap-3 px-5 text-center">
        <h1 className="text-h2 text-text-primary">{t("errors.crashed")}</h1>
        <p className="text-small text-text-secondary">{t("errors.crashedBody")}</p>
      </section>
    );
  }
}

export const ErrorBoundary = withTranslation()(ErrorBoundaryBase);
